import React from 'react'
import ReactDisqusComments from 'react-disqus-comments'

const Comments = (props) => {

  const { title, path, comments } = props.data;

  if ( comments === false || process.env.NODE_ENV === 'development' ) {
    return <div></div>;
  }

  return (
    <ReactDisqusComments
      shortname="dhruvkumarjha"
      identifier={ path }
      title={ title }
      url={`http://www.dhruvkumarjha.com${ path }`}
    />
  );

}


export default Comments



// WEBPACK FOOTER //
// ./src/global/components/posts/Comments.js